module.exports = "/images/discover.svg";